import React from 'react';
import { ConciliacaoVendizap } from './BpoFinConciliacaoVendizap';

// Conciliação Asaas Vend. (30/10/2026): mesma página da conciliação Stripe, com o provedor Asaas.
export default function BpoFinConciliacaoAsaasVendizap() { return <ConciliacaoVendizap provedor="asaas" />; }
